// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__18SMR","upload":"Small_upload__tNocH","imageWrap":"Small_imageWrap__3eoLL","removeBtn":"Small_removeBtn__7TAKX"};